import { ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';

type ToastProps = {
  title?: string;
  description?: string | ReactNode;
  variant?: 'default' | 'destructive';
  action?: ReactNode;
  position?:
    | 'top-right'
    | 'top-center'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left';
  duration?: number;
  id?: string;
};

export const useToast = () => {
  const toast = ({
    title,
    description,
    variant = 'default',
    action,
    position = 'top-center',
    duration = 5000,
    id,
  }: ToastProps) => {
    // Create a unique ID if not provided
    const toastId = id || Math.random().toString(36).substring(2, 9);

    // Use the appropriate toast method based on variant
    if (variant === 'destructive') {
      return sonnerToast.error(title, {
        id: toastId,
        description,
        action,
        position,
        duration,
      });
    }

    // Default toast
    return sonnerToast(title, {
      id: toastId,
      description,
      action,
      position,
      duration,
    });
  };

  const dismiss = (toastId?: string) => {
    if (toastId) {
      sonnerToast.dismiss(toastId);
    } else {
      sonnerToast.dismiss();
    }
  };

  return {
    toast,
    dismiss,
  };
};
